import React from 'react';

import ResourcesCell from './ResourcesCell';
import classes from './ResourcesBlock.module.scss';

export default ({
  resources,
  height,
  mergeTimesheetPlaces,
  aggregatedAiResults,
  employeesWithOvertime,
}) => {
  return (
    <div className={classes.resourcesBlock}>
      {
        resources.map((item, index) => {
          const placeId = mergeTimesheetPlaces ? 0 : item.place_id;
          const key = `${item.id}_${placeId}`;
          const isOvertime = employeesWithOvertime[key] && Object.values(employeesWithOvertime[key]).some((day) => day.isOvertime);
          const overtimeDays = employeesWithOvertime[key] ? Object.entries(employeesWithOvertime[key]).filter(([day, item]) => item.isOvertime).map(([day, item]) => item.date) : [];
          return (
            <ResourcesCell
              title={item.title}
              photo={item.photo}
              skill={item.skill}
              isOvertime={isOvertime}
              overtimeDays={overtimeDays}
              place={mergeTimesheetPlaces ? '' : item.place}
              height={height}
              key={index}
              rowId={item.id}
              index={index}
              aggregatedAiResults={aggregatedAiResults[item.id]}
            />
          )
        })
      }
    </div>
  );
}